import {getBranchItemByBookmarkPresentationID} from "@/helpers/tree-helper.js";
import {addLayerActiveById, removeLayerActive} from "@/helpers/ol/ol-layer-active-helper.js";

export function clickCheckbox(element, label, catalog, depth, key) {
    if(element.type === 'checkbox') {

        document.querySelector('layer-menu-overview layer-menu-group-merged[data-label="' + label + '"]').closest('layer-menu-group').querySelector('.card').querySelectorAll('input').forEach(input => {

            const branchItem = getBranchItemByBookmarkPresentationID(input.value)
            if( (branchItem.parent && branchItem.parent.BoundingBoxType === undefined) || (branchItem.checked === 1 || branchItem.defaultChecked === 1)) {
                if (element.checked && !input.checked) {
                    input.click()

                    addLayerActiveById(branchItem.ID)

                    // console.log('click')
                }
                if (!element.checked && input.checked) {
                    input.click()

                    removeLayerActive(branchItem.ID)

                    // console.log('click 2')
                }
            }
        })

        // console.log(catalog)

        if(catalog !== 'false') {


            // console.log(element.checked)

            if(element.checked) {
                if(!document.querySelector('layer-menu-active layer-menu-group-merged[data-label="' + label + '"]')) {

                    // console.log(label)

                    let selector = 'layer-active'
                    document.getElementById(selector).insertAdjacentHTML(
                        "beforeend",
                        `<layer-menu-group-merged data-checked="true" data-label="${label}" data-depth="${depth}" data-key="${key}" data-catalog="false"></layer-menu-group-merged>`
                    )
                }
            } else {
                const item = document.querySelector('layer-menu-active layer-menu-group-merged[data-label="' + label + '"]')
                if(item) {
                    item.remove()
                }
            }
        }
    }
}
